// 大問画像表示画面用の外部サービス用コード
export const KAKOMON_ALLOW_CODE_LIST = [
  'cMXPky5uGuwd', // ベネッセ
  'zqXZMm9JjNPA', // 駿台
  'gw4JgMq26f9d', // 駿台（開発1用）
  'CDL9jGz4Nv6t' // 駿台（開発2用）
];
